<script lang="ts">
  import Button from "$components/MatomoButton.svelte";
  import Link from "$components/MatomoLink.svelte";
  import { showError } from "$lib/alerts";
  import type { ComponentProps } from "svelte";

  type Variant = "button" | "link";
  type AsyncEventHandler = (e?: MouseEvent) => Promise<any>;

  type $$Props = ComponentProps<Button> & {
    onClick: AsyncEventHandler;
    variant?: Variant;
  };

  export let isLoading = false;
  export let isDisabled = false;
  export let onClick: AsyncEventHandler;
  export let variant: Variant = "button";

  const variantComponentMap: Record<Variant, any> = {
    "button": Button,
    "link": Link,
  };

  let _isLoading = false;
  const handleClick = async (e: MouseEvent) => {
    _isLoading = true;
    try {
      await onClick(e);
    } catch (e) {
      showError({ error: e });
    }
    _isLoading = false;
  };

  // This is to allow the parent component to bind and observe changes without having access to change the internal _isLoading prop.
  $: isLoading = _isLoading;
</script>

<svelte:component
  this={variantComponentMap[variant]}
  {...$$restProps}
  onClick={handleClick}
  isLoading={_isLoading}
  isDisabled={_isLoading || isDisabled}
>
  <slot name="icon-before" slot="icon-before" />
  <slot name="loading" slot="loading">
    <slot />
  </slot>
  <slot />
  <slot name="icon-after" slot="icon-after" />
</svelte:component>
